/**
 * Token do convite de recuperação do 2º fator (item 4B-2).
 *
 * Mesmo desenho do link de redefinição de senha (utils/segredoDoLink.js):
 * `capturarTokenDeRecuperacaoMfa()` roda em `index.js` ANTES de o React montar,
 * lê o `#t=` de `/recuperar-mfa`, apaga o fragmento da barra e guarda o token só
 * em memória. Não vai ao localStorage nem à URL depois da captura.
 */
const FORMATO = /^[A-Za-z0-9_-]{43}$/;
let token = '';

export function capturarTokenDeRecuperacaoMfa(janela = window) {
    const { pathname, hash } = janela.location;
    if (pathname !== '/recuperar-mfa' || !hash) return;
    const lido = new URLSearchParams(hash.replace(/^#/, '')).get('t') || '';
    janela.history.replaceState(null, '', pathname);
    token = FORMATO.test(lido) ? lido : '';
}

export function obterTokenDeRecuperacaoMfa() {
    return token;
}

export function descartarTokenDeRecuperacaoMfa() {
    token = '';
}
